/* ============================================================================
FILE: po-katupirsia5-apakan-texts-fr-en-es-20260305.js
MODE: JS FR/EN/ES (injection tri) + lexicon override (termes FR) si présent
API:  window.PoKatupirsia5ApakanTextsFR_EN_ES_20260305

ROLE:
  - Injecte le contenu FR/EN/ES dans les slots selon la langue choisie (localStorage).
  - Lang storage:
      - clé principale : po_lex_lang
      - clé compat :     goody_gp_lang
    Langues autorisées : fr, en, es.
  - Expose getLang(), setLang(lang), init() et stopAudio() ; déclenche po:locale-changed après bascule.
  - Écoute po:lexicon-ready pour re-render si le lexique arrive après.
  - Protection fine PRIORITAIRE : verrouille (translate="no") TOUTES les occurrences du lexique simplifié
    FR canonique via meta.lexique_simplifie_fr (si dispo), variantes apostrophes + œ/oe,
    + anti-collage (espaces DOM uniquement quand nécessaire).
  - IMPORTANT : les entrées lexicales canoniques restent en FR quelle que soit la langue affichée.
  - Ajoute une couche audio générale + audio locale par bloc, sans casser le socle existant.
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_K5_APAKAN_TEXTS_20260305__) return;
  window.__PO_K5_APAKAN_TEXTS_20260305__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-axis-section[data-po-axis]';
  var TARGET_ID = 'apakan';

  var IMG_IDEOGRAM_CONCEPT = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Apakan_copie2.png?v=1772894672';
  var IMG_ELEMENT = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535';
  var IMG_TOTEM = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195';
  var IMG_FREQ_44 = 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_44.png?v=1773411757';

  var CANON = {
    title: 'Àpákan',
    page_terms: [
      'Àpákan',
      'Katûpirsia',
      'Katûpirsia 5',
      'La Matrice-substrat',
      'Balakallpa',
      'La Katûvýs',
      'Katûvýs',
      'Êkhö',
      'RéZonans',
      'Katûvýsqun',
      'Axis',
      'Organon',
      'Posœnnoïa',
      'Posœnnoïsme',
      'Katûfragmya',
      'Synchrêssions',
      'Katûvýs picturale',
      'nombre-guide'
    ]
  };

  function clampStr(v){ return (v == null) ? '' : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, '-');
    if (s.indexOf('fr') === 0) return 'fr';
    if (s.indexOf('en') === 0) return 'en';
    if (s.indexOf('es') === 0) return 'es';
    if (s.indexOf('pt') === 0) return 'es';
    return '';
  }

  function readStoredLang(){
    try{
      var v = localStorage.getItem(STORAGE_KEY);
      v = normLang(v);
      if (v) return v;
    }catch(e){}
    try{
      var v2 = localStorage.getItem(STORAGE_KEY_COMPAT);
      v2 = normLang(v2);
      if (v2) return v2;
    }catch(e){}
    return '';
  }

  var __PO_HTML_LANG_SYNC__ = false;

  function storeLang(lang){
    var v = normLang(lang) || 'fr';
    try{ localStorage.setItem(STORAGE_KEY, v); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, v); }catch(e){}
    try{
      if (document && document.documentElement){
        var currentLang = normLang(document.documentElement.getAttribute('lang') || '') || '';
        if (currentLang !== v){
          __PO_HTML_LANG_SYNC__ = true;
          document.documentElement.setAttribute('lang', v);
          setTimeout(function(){ __PO_HTML_LANG_SYNC__ = false; }, 0);
        }
      }
    }catch(e){ __PO_HTML_LANG_SYNC__ = false; }
    return v;
  }

  function detectBrowserLang(){
    try{
      var dl = (document && document.documentElement) ? (document.documentElement.getAttribute('lang') || '') : '';
      var dln = normLang(dl);
      if (dln) return dln;
    }catch(e){}
    try{
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || '';
      var v = normLang(n);
      if (v) return v;
    }catch(e){}
    return 'fr';
  }

  function getLang(){
    return readStoredLang() || detectBrowserLang() || 'fr';
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event('po:locale-changed'));
    }catch(e){
      try{
        var ev = document.createEvent('Event');
        ev.initEvent('po:locale-changed', true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function getTargetBlocks(){
    var nodes = [];
    try{
      var all = document.querySelectorAll(ROOT_SEL);
      for (var i=0;i<all.length;i++){
        var id = '';
        try{ id = all[i].getAttribute('data-po-lex-id') || ''; }catch(e){ id = ''; }
        if (id === TARGET_ID) nodes.push(all[i]);
      }
    }catch(e){}
    return nodes;
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}
    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return '';
    try{ if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]); }catch(e){}
    return '';
  }

  function pickDefShort(entry, lang){
    if (!entry) return '';
    var ks = 'definition_short_' + lang;
    var k  = 'definition_' + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k]) return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].short) return clampStr(entry.defs[lang].short);
    }catch(e){}
    return '';
  }

  function pickDefLong(entry, lang){
    if (!entry) return '';
    var kl = 'definition_long_' + lang;
    var k  = 'definition_' + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k]) return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].long) return clampStr(entry.defs[lang].long);
    }catch(e){}
    return '';
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + '_' + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  function pickAny(entry, key, fallback){
    try{ if (entry && entry[key] != null) return entry[key]; }catch(e){}
    return fallback;
  }

  /* --------------------------------------------------------------------------
   * PROTECTION FINE
   * -------------------------------------------------------------------------- */

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/\"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function uniqPush(arr, v, seen){
    var k = clampStr(v);
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, '’'), seen);
    uniqPush(out, t.replace(/œ/g, 'oe').replace(/Œ/g, 'OE'), seen);
    uniqPush(out, t.replace(/oe/g, 'œ').replace(/OE/g, 'Œ'), seen);

    var oe1 = t.replace(/œ/g, 'oe').replace(/Œ/g, 'OE');
    var oe2 = t.replace(/oe/g, 'œ').replace(/OE/g, 'Œ');
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, '’'), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, '’'), seen);
    return out;
  }

  function getSimplifiedLexiqueFRList(){
    var out = [];
    var seen = Object.create(null);

    function addMany(arr){
      if (!Array.isArray(arr)) return;
      for (var i=0;i<arr.length;i++) uniqPush(out, arr[i], seen);
    }

    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        addMany(window.PO_LEXICON_META.lexique_simplifie_fr);
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        addMany(window.PO_LEXICON.meta.lexique_simplifie_fr);
      }
    }catch(e){}
    addMany(CANON.page_terms);
    return out;
  }

  var __PO_PROTECT_CACHE__ = { key:'', re:null };

  function buildProtectMatcher(){
    var base = getSimplifiedLexiqueFRList();
    var variants = [];
    var seen = Object.create(null);
    for (var i=0;i<base.length;i++){
      var list = buildVariants(base[i]);
      for (var j=0;j<list.length;j++) uniqPush(variants, list[j], seen);
    }
    variants.sort(function(a,b){ return b.length - a.length; });
    var parts = [];
    for (var k=0;k<variants.length;k++) parts.push(escapeRegExp(variants[k]));
    if (!parts.length) return null;
    try{ return new RegExp('(' + parts.join('|') + ')', 'g'); }catch(e){ return null; }
  }

  function ensureProtectEngineReady(){
    var key = 'meta:none';
    try{ var l = getSimplifiedLexiqueFRList(); key = 'meta:' + (l ? l.length : 0); }catch(e){ key = 'meta:none'; }
    if (__PO_PROTECT_CACHE__.key === key) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectMatcher();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute('translate');
    if (tr && String(tr).toLowerCase() === 'no') return true;
    var cls = el.className || '';
    if (typeof cls === 'string'){
      if (cls.indexOf('notranslate') !== -1) return true;
      if (cls.indexOf('po-lex-protect') !== -1) return true;
      if (cls.indexOf('po-axis-audio-wrap') !== -1) return true;
      if (cls.indexOf('po-axis-audio-btn') !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch || '');
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;
    re.lastIndex = 0;
    if (!re.test(txt)) return;
    re.lastIndex = 0;

    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;
    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var hit = m[0];
      var end = start + hit.length;

      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : '';
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(' '));

      var span = doc.createElement('span');
      span.setAttribute('translate', 'no');
      span.className = 'po-lex-protect notranslate';
      span.textContent = hit;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : '';
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(' '));

      last = end;
      if (hit.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;

    var walker;
    try{
      walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            var p = n.parentNode;
            var pn = p && p.nodeName ? p.nodeName : '';
            if (pn === 'SCRIPT' || pn === 'STYLE') return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return; }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
  }

  function protectKeywordsHTML(html){
    var s = clampStr(html);
    if (!s) return '';
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return s;

    var tpl = document.createElement('template');
    tpl.innerHTML = s;
    var root = tpl.content || tpl;
    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return s; }
    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt);
    if (!s) return '';
    return '<p>' + escapeHTML(s).replace(/\n+/g, '</p><p>') + '</p>';
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: '',
    speaking: false,
    utterance: null
  };

  var AUDIO_UI = {
    fr: { general: 'Écouter le texte', block: 'Écouter ce bloc', stop: 'Arrêter la lecture' },
    en: { general: 'Listen to the text', block: 'Listen to this section', stop: 'Stop playback' },
    es: { general: 'Escuchar el texto', block: 'Escuchar este bloque', stop: 'Detener la lectura' }
  };

  function audioUI(lang){
    var L = normLang(lang) || 'fr';
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function ensureAudioStyles(){
    if (document.getElementById('po-axis-audio-styles-katupirsia-20260303')) return;
    var st = document.createElement('style');
    st.id = 'po-axis-audio-styles-katupirsia-20260303';
    st.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;margin:10px 0 12px;}',
      '.po-axis-audio-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;border:1px solid rgba(184,134,11,.45);border-radius:999px;padding:8px 12px;background:rgba(0,0,0,.02);font:inherit;font-weight:800;letter-spacing:.2px;cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;box-shadow:0 0 0 1px rgba(184,134,11,.12),0 8px 18px rgba(31,122,58,.10);}',
      '.po-axis-audio-btn:hover{box-shadow:0 0 0 1px rgba(184,134,11,.24),0 10px 24px rgba(31,122,58,.14);}',
      '.po-axis-audio-btn.is-active{border-color:rgba(31,122,58,.55);box-shadow:0 0 0 1px rgba(31,122,58,.20),0 12px 28px rgba(31,122,58,.18);}',
      '.po-axis-audio-btn__label{color:var(--color-accent,#1f7a3a);}',
      '.po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;padding:6px 10px;font-size:12px;}',
      '.po-lex-summary .po-axis-audio-btn__label{white-space:nowrap;}',
      '@media (max-width:760px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{order:3;width:100%;justify-content:center;margin-top:8px;}}'
    ].join('');
    document.head.appendChild(st);
  }

  function createAudioButton(role, index){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role);
    if (index != null) btn.setAttribute('data-po-audio-index', String(index));
    btn.setAttribute('aria-pressed', 'false');
    btn.innerHTML = '<span class="po-axis-audio-btn__label"></span>';
    return btn;
  }

  function getAudioButtonLabel(role, lang, isActive){
    var ui = audioUI(lang);
    if (isActive) return ui.stop;
    return role === 'general' ? ui.general : ui.block;
  }

  function updateAudioButtonLabel(btn, lang, isActive){
    if (!btn) return;
    var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block');
    var label = btn.querySelector('.po-axis-audio-btn__label') || btn;
    label.textContent = getAudioButtonLabel(role, lang, !!isActive);
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    if (isActive) btn.classList.add('is-active'); else btn.classList.remove('is-active');
  }

  function updateAudioButtonsState(root, lang){
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn[data-po-audio-role]');
    var activeKey = (PO_AUDIO_STATE.root === root) ? PO_AUDIO_STATE.activeKey : '';
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block');
      var idx = clampStr(btn.getAttribute('data-po-audio-index') || '');
      var key = (role === 'general') ? 'general' : ('block-' + idx);
      updateAudioButtonLabel(btn, lang, key && key === activeKey && PO_AUDIO_STATE.speaking);
    }
  }

  function stopAudio(resetButtons){
    try{ if (PO_AUDIO_SYNTH) PO_AUDIO_SYNTH.cancel(); }catch(e){}
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.speaking = false;
    PO_AUDIO_STATE.utterance = null;
    if (resetButtons !== false){
      var roots = getTargetBlocks();
      for (var i=0;i<roots.length;i++) updateAudioButtonsState(roots[i], getLang());
    }
  }

  function cleanAudioText(s){
    return clampStr(s).replace(/\s+/g, ' ').replace(/[•·]+/g, '. ').replace(/\s([;:!?])/g, '$1').trim();
  }

  function collectTextFromNode(node){
    if (!node) return '';
    var clone = node.cloneNode(true);
    try{
      var kill = clone.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn, script, style, [aria-hidden="true"]');
      for (var i=0;i<kill.length;i++) if (kill[i] && kill[i].parentNode) kill[i].parentNode.removeChild(kill[i]);
    }catch(e){}
    return cleanAudioText(clone.textContent || '');
  }

  function buildGeneralText(root){
    var parts = [];
    var slots = ['title', 'kicker', 'h_def', 'def_short', 'def_long'];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = collectTextFromNode(el);
      if (txt) parts.push(txt);
    }
    return cleanAudioText(parts.join('. '));
  }

  function buildDetailText(detail){
    if (!detail) return '';
    var parts = [];
    var title = detail.querySelector('.po-lex-summary__title');
    var titleTxt = collectTextFromNode(title);
    if (titleTxt) parts.push(titleTxt);

    var bodyClone = detail.cloneNode(true);
    try{
      var summary = bodyClone.querySelector('summary');
      if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
      var kill = bodyClone.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn, script, style');
      for (var i=0;i<kill.length;i++) if (kill[i] && kill[i].parentNode) kill[i].parentNode.removeChild(kill[i]);
    }catch(e){}
    var bodyTxt = cleanAudioText(bodyClone.textContent || '');
    if (bodyTxt) parts.push(bodyTxt);
    return cleanAudioText(parts.join('. '));
  }

  function splitTextForSpeech(text, limit){
    var maxLen = limit || 220;
    var raw = cleanAudioText(text);
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:…]+[.!?;:…]?/g) || [raw];
    var out = [];
    var current = '';
    for (var i=0;i<pieces.length;i++){
      var piece = cleanAudioText(pieces[i]);
      if (!piece) continue;
      if (((current ? current + ' ' : '') + piece).length > maxLen){
        if (current) out.push(current.trim());
        if (piece.length > maxLen){
          var words = piece.split(/\s+/);
          var acc = '';
          for (var j=0;j<words.length;j++){
            var w = words[j];
            if (!w) continue;
            var next = acc ? (acc + ' ' + w) : w;
            if (next.length > maxLen){
              if (acc) out.push(acc.trim());
              acc = w;
            } else acc = next;
          }
          current = acc || '';
        } else current = piece;
      } else current = current ? (current + ' ' + piece) : piece;
    }
    if (current) out.push(current.trim());
    return out;
  }

  function pickSpeechVoice(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== 'function') return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    if (!voices.length) return null;
    var code = normLang(lang || getLang()) || 'fr';
    var prefixes = code === 'fr' ? ['fr','fr-'] : (code === 'es' ? ['es','es-'] : ['en','en-']);
    for (var i=0;i<voices.length;i++){
      var vLang = clampStr(voices[i].lang).toLowerCase();
      if (!vLang) continue;
      for (var j=0;j<prefixes.length;j++) if (vLang === prefixes[j] || vLang.indexOf(prefixes[j]) === 0) return voices[i];
    }
    return voices[0] || null;
  }

  function buildAudioUnits(root, startKey){
    var units = [];
    if (!root) return units;
    var details = root.querySelectorAll('.po-lex-details');
    var startAt = 0;
    var useGeneral = (startKey === 'general');
    if (useGeneral){
      var generalTxt = buildGeneralText(root);
      if (generalTxt) units.push({ key:'general', kind:'general', text:generalTxt, detail:null });
      startAt = 0;
    } else {
      var parsed = parseInt(String(startKey || '').replace(/^block-/, ''), 10);
      startAt = isNaN(parsed) ? 0 : parsed;
    }
    for (var i=startAt;i<details.length;i++){
      var txt = buildDetailText(details[i]);
      if (txt) units.push({ key:'block-' + i, kind:'block', text:txt, detail:details[i] });
    }
    return units;
  }

  function openDetailIfNeeded(unit){
    if (!unit || unit.kind !== 'block' || !unit.detail) return;
    try{ unit.detail.open = true; }catch(e){}
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.speaking) return;
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
        stopAudio(true);
        return;
      }
      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      PO_AUDIO_STATE.chunks = splitTextForSpeech(unit.text, 220);
      PO_AUDIO_STATE.chunkPos = -1;
      openDetailIfNeeded(unit);
      if (PO_AUDIO_STATE.root) updateAudioButtonsState(PO_AUDIO_STATE.root, getLang());
      if (!PO_AUDIO_STATE.chunks.length){ speakNextChunk(); return; }
      speakNextChunk();
      return;
    }
    var chunk = clampStr(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    if (!chunk){ speakNextChunk(); return; }
    var utt;
    try{ utt = new SpeechSynthesisUtterance(chunk); }catch(e){ stopAudio(true); return; }
    var lang = getLang();
    utt.lang = lang === 'fr' ? 'fr-FR' : (lang === 'es' ? 'es-ES' : 'en-US');
    var voice = pickSpeechVoice(lang);
    if (voice) utt.voice = voice;
    utt.rate = 0.96;
    utt.pitch = 1;
    utt.volume = 1;
    utt.onend = function(){ PO_AUDIO_STATE.utterance = null; speakNextChunk(); };
    utt.onerror = function(){ PO_AUDIO_STATE.utterance = null; speakNextChunk(); };
    PO_AUDIO_STATE.utterance = utt;
    try{ PO_AUDIO_SYNTH.speak(utt); }catch(e){ stopAudio(true); }
  }

  function startAudio(root, startKey){
    if (!PO_AUDIO_SYNTH || !root) return;
    var sameRoot = (PO_AUDIO_STATE.root === root);
    var sameKey = (PO_AUDIO_STATE.activeKey === startKey);
    if (sameRoot && sameKey && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)){
      stopAudio(true);
      return;
    }
    stopAudio(false);
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildAudioUnits(root, startKey);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = startKey;
    PO_AUDIO_STATE.speaking = true;
    updateAudioButtonsState(root, getLang());
    speakNextChunk();
  }

  function bindAudioButton(btn, root){
    if (!btn || !root || btn.__poAudioBound) return;
    btn.addEventListener('click', function(ev){
      if (ev && typeof ev.preventDefault === 'function') ev.preventDefault();
      if (ev && typeof ev.stopPropagation === 'function') ev.stopPropagation();
      if (!PO_AUDIO_SYNTH) return;
      var role = clampStr(btn.getAttribute('data-po-audio-role') || 'block');
      var idx = clampStr(btn.getAttribute('data-po-audio-index') || '');
      var key = (role === 'general') ? 'general' : ('block-' + idx);
      startAudio(root, key);
    });
    btn.__poAudioBound = true;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();
    var panel = root.querySelector('.po-lex-panel');
    if (!panel) return;

    var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
    if (!generalWrap){
      generalWrap = document.createElement('div');
      generalWrap.className = 'po-axis-audio-wrap';
      generalWrap.setAttribute('data-po-audio-role', 'general');
      var generalBtn = createAudioButton('general');
      generalWrap.appendChild(generalBtn);
      var meta = root.querySelector('.po-axis-meta');
      var defShort = root.querySelector('[data-po-slot="def_short"]');
      var firstDetail = panel.querySelector('.po-lex-details');
      if (meta && meta.parentNode){
        if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling); else meta.parentNode.appendChild(generalWrap);
      } else if (defShort && defShort.parentNode){
        defShort.parentNode.insertBefore(generalWrap, defShort);
      } else if (firstDetail && firstDetail.parentNode){
        firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
      } else panel.appendChild(generalWrap);
    }

    var generalButton = generalWrap.querySelector('.po-axis-audio-btn[data-po-audio-role="general"]');
    if (!generalButton){
      generalButton = createAudioButton('general');
      generalWrap.appendChild(generalButton);
    }
    bindAudioButton(generalButton, root);

    var details = root.querySelectorAll('.po-lex-details');
    for (var i=0;i<details.length;i++){
      details[i].setAttribute('data-po-audio-index', String(i));
      var summary = details[i].querySelector('.po-lex-summary');
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="block"]');
      if (!btn){
        btn = createAudioButton('block', i);
        summary.appendChild(btn);
      } else btn.setAttribute('data-po-audio-index', String(i));
      bindAudioButton(btn, root);
    }

    updateAudioButtonsState(root, lang || getLang());
  }

  function initAudioEverywhere(lang){
    var l = normLang(lang || getLang()) || 'fr';
    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++) ensureAudioButtons(roots[i], l);
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.getVoices === 'function'){
      PO_AUDIO_SYNTH.onvoiceschanged = function(){
        try{ initAudioEverywhere(getLang()); }catch(e){}
      };
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * FALLBACKS KATÛVÝSQUN
   * -------------------------------------------------------------------------- */

  var FALLBACK_FR = {
    title: CANON.title,
    kicker: 'Extrait du <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Bande Balakallpa ; unité élémentaire de Katûpirsia ; nombre-guide 44)',
    cta_translate: 'Proposer une traduction du concept',
    h_def: 'Définition opérative',
    chips: ['Élément', 'Totem', 'Fréquence'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_44],
    def_short: 'Fragment vibratoire actif ; unité fractale de transmission et de seuil.',
    def_long:
      'Porte une charge de sens autonome tout en restant relié au tout. Active une recomposition par la partie : seuil opératif, nœud de RéZonans, module transitoire de transformation.\n\n' +
      'Dans Katûpirsia 5, Àpákan est défini comme l’unité vibratoire élémentaire de la Katûpirsia. Il se donne comme forme vivante et zone vibratoire fractale, particule de transmission révélant l’architecture posœnnoïale du multiple au sein de l’unité fluide. Le texte le qualifie de nœud spiralé d’expression transmutative : chaque Àpákan porte une orientation symbolique singulière, une tension propre, et une capacité d’activation autonome inscrite dans une logique de co-présence rituelle et de résonance structurelle avec l’ensemble.\n\n' +
      'Àpákan fragmente sans rompre. Il rend le passage praticable par la partie : portion singulière d’un champ énergétique, nœud de sens distinct et relié, capable d’ouvrir un seuil, d’ancrer une modulation rituelle et de reconfigurer les syntonies du système par sa seule intensité. Le paradigme est explicite : le fragment porte mémoire du tout, et sa mise en action participe à une recomposition permanente par rémanence, syntonie et activation transitoire.\n\n' +
      'Dans Katûpirsia, Àpákan fonctionne comme organe symbolique autonome et unité processuelle d’activation. Il croise intention, mémoire, RéZonans et matérialisation pour engendrer une expression transitoire du tout, localisée mais reliée. Dans Axis, le corpus situe dix Àpákan fondamentaux comme structure vibratoire centrale de l’Organon, au voisinage direct de Posœnnoïa, verbe-source qui traverse et engendre l’ensemble.',
    h_features: 'Déploiement',
    h_questions: 'Tests d’usage',
    hint_fold: 'déplier',
    hint_fold2: 'déplier',
    hint_fold3: 'déplier',
    example_title: 'Phrase opérative',
    example: '« Àpákan : j’ouvre l’appel, je découpe le seuil, et j’active l’unité vivante qui recompose le tout. »',
    features: [
      'Statut canonique : unité vibratoire élémentaire de la Katûpirsia ; forme vivante et zone vibratoire fractale, particule de transmission révélant l’architecture posœnnoïale du multiple au sein de l’unité fluide.',
      'Fonction principale : fragmente sans rompre ; rend le passage praticable par la partie, capable d’ouvrir un seuil, d’ancrer une modulation rituelle et de reconfigurer les syntonies par intensité.',
      'Segmentation rythmique canonique : À–Pá–Kan (appel → découpe → activation).',
      'Relations systémiques : Katûpirsia, La Katûvýs, Axis ; milieux d’usage : Katûvýs picturale, Katûpirsia, Katûvýsqun, Synchrêssions.',
      'Mode d’invocation : nommer l’Àpákan, porter la phrase d’intensité si individualisé, accorder la signature 44, laisser jouer la triade opérative.'
    ],
    questions: [
      'Si tu veux ouvrir un passage par un fragment : « j’active un Àpákan ».',
      'Si une partie doit parler pour le tout : « cet Àpákan porte la charge ».',
      'Si une recomposition s’opère localement : « l’Àpákan travaille ».',
      'Si tu dois accorder un fragment au champ sans le dissoudre : « je tiens l’Àpákan et la totalité répond ». '
    ],
    h_family: 'Position & relations',
    family_1: '<p><strong>Position systémique :</strong> dans <strong>Katûpirsia</strong>, <strong>Àpákan</strong> fonctionne comme organe symbolique autonome et unité processuelle d’activation. Il croise intention, mémoire, <strong>RéZonans</strong> et matérialisation pour engendrer une expression transitoire du tout, localisée mais reliée.</p>',
    family_2: '<p><strong>Élément / Totem / Signature :</strong> Élément : <strong>La Katûvýs</strong> ; Totem : <strong>Êkhö</strong> ; Fréquence (<strong>nombre-guide</strong>) : 44. L’Àpákan agit comme fragment actif baignant dans la matrice-substrat, porteur d’une qualité de passage et d’une tenue propre orientée vers la recomposition.</p>',
    h_wordbuild: 'Construction du nom & fréquence 44',
    word_blocks: [
      { head: 'Origine (K5)', text: 'Construction néologique : yorùbá (àpá + kan), stabilisée par K5.' },
      { head: 'àpá', text: 'Sens attesté : partie, portion, côté, segment. Résonance posœnnoïale : fragment opératif, zone de condensation.' },
      { head: 'kan', text: 'Sens attesté : un, unique, distinct. Résonance posœnnoïale : singularité active, unité d’activation.' },
      { head: 'Triade À–Pá–Kan', text: 'À : souffle initial, appel, ouverture de l’invocation. Pá : coupure / délimitation ; naissance d’un espace symbolique. Kan : unité active ; singularité vibratoire activable.' },
      { head: 'Fréquence 44', text: '44 agit comme signature vibratoire minimale : axe de nomination, vibration, invocation, projection rituelle. 4 + 4 = 8 : transmutation maîtrisée, structure stable, résonance équilibrée ; 2 × 22 : double structure de parole fondatrice et de cycle dual stabilisé.' }
    ],
    word_notes: [
      'Champ : Katûpirsia / La Katûvýs ; Totem : Êkhö ; Fréquence : 44.',
      'Le paradigme est explicite : le fragment porte mémoire du tout ; sa mise en action participe à une recomposition permanente par rémanence, syntonie et activation transitoire.',
      'Le titre reste en FR (terme du lexique), quelle que soit la langue de l’interface.'
    ]
  };

  var FALLBACK_EN = {
    title: CANON.title,
    kicker: 'Excerpt from <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Balakallpa band; elementary unit of Katûpirsia; nombre-guide 44)',
    cta_translate: 'Propose a translation of the concept',
    h_def: 'Operative definition',
    chips: ['Element', 'Totem', 'Frequency'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_44],
    def_short: 'Fragment vibratoire actif ; unité fractale de transmission et de seuil.',
    def_long:
      'Carries an autonomous charge of meaning while remaining linked to the whole. Activates recomposition through the part: an operative threshold, a node of RéZonans, a transitional module of transformation.\n\n' +
      'In Katûpirsia 5, Àpákan is defined as the elementary vibratory unit of Katûpirsia. It appears as a living form and a fractal vibratory zone, a particle of transmission revealing the posœnnoïal architecture of the multiple within fluid unity.\n\n' +
      'Àpákan fragments without breaking. It makes passage practicable through the part: a singular portion of an energetic field, a distinct and linked node of meaning, able to open a threshold, anchor a ritual modulation and reconfigure syntonies by its sole intensity.\n\n' +
      'Within Katûpirsia, Àpákan functions as an autonomous symbolic organ and a processual unit of activation. It crosses intention, memory, RéZonans and materialization to engender a transitory expression of the whole—localized yet linked. In Axis, ten fundamental Àpákan structure the vibratory core of the Organon near Posœnnoïa.',
    h_features: 'Unfolding',
    h_questions: 'Use tests',
    hint_fold: 'expand',
    hint_fold2: 'expand',
    hint_fold3: 'expand',
    example_title: 'Operative phrase',
    example: '“Àpákan: I open the call, I cut the threshold, and I activate the living unit that recomposes the whole.”',
    features: [
      'Canonical status: elementary vibratory unit of Katûpirsia; a living form and fractal vibratory zone, a particle of transmission revealing the architecture of the multiple within fluid unity.',
      'Main function: fragments without breaking; makes passage practicable through the part, able to open a threshold, anchor a ritual modulation and reconfigure syntonies by intensity.',
      'Canonical rhythmic segmentation: À–Pá–Kan (call → cut → activation).',
      'Systemic relations: Katûpirsia, La Katûvýs, Axis; use milieux: Katûvýs picturale, Katûpirsia, Katûvýsqun, Synchrêssions.',
      'Invocation mode: name the Àpákan, carry the intensity phrase if individualized, tune signature 44, let the operative triad act.'
    ],
    questions: [
      'If you want to open a passage through a fragment: “I activate an Àpákan.”',
      'If a part must speak for the whole: “this Àpákan carries the charge.”',
      'If recomposition happens locally: “the Àpákan is working.”',
      'If a fragment must be tuned to the field without dissolving: “I hold the Àpákan and the whole responds.”'
    ],
    h_family: 'Position & relations',
    family_1: '<p><strong>Systemic position:</strong> within <strong>Katûpirsia</strong>, <strong>Àpákan</strong> functions as an autonomous symbolic organ and a processual unit of activation. It crosses intention, memory, <strong>RéZonans</strong> and materialization to generate a transitory expression of the whole—localized yet linked.</p>',
    family_2: '<p><strong>Element / Totem / Signature:</strong> Element: <strong>La Katûvýs</strong>; Totem: <strong>Êkhö</strong>; Frequency (<strong>nombre-guide</strong>): 44. Àpákan acts as an active fragment bathed in the matrix-substrate, bearing a quality of passage and a proper hold oriented toward recomposition.</p>',
    h_wordbuild: 'Name construction & frequency 44',
    word_blocks: [
      { head: 'Origin (K5)', text: 'Neological construction: yorùbá (àpá + kan), stabilized by K5.' },
      { head: 'àpá', text: 'Attested sense: part, portion, side, segment. Posœnnoïal resonance: operative fragment, zone of condensation.' },
      { head: 'kan', text: 'Attested sense: one, unique, distinct. Posœnnoïal resonance: active singularity, unit of activation.' },
      { head: 'Triad À–Pá–Kan', text: 'À: initial breath, call, opening of invocation. Pá: cut / delimitation; birth of a symbolic space. Kan: active unit; activable vibratory singularity.' },
      { head: 'Frequency 44', text: '44 acts as a minimal vibratory signature: axis for naming, vibrating, invoking and ritual projection. 4 + 4 = 8: mastered transmutation, stable structure, balanced resonance; 2 × 22: doubled founding speech and stabilized dual cycle.' }
    ],
    word_notes: [
      'Field: Katûpirsia / La Katûvýs ; Totem: Êkhö ; Frequency: 44.',
      'The paradigm is explicit: the fragment carries memory of the whole; its activation participates in ongoing recomposition through remanence, syntony and transitory activation.',
      'The title remains in FR (lexicon term), whatever the interface language.'
    ]
  };

  var FALLBACK_ES = {
    title: CANON.title,
    kicker: 'Extracto de <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Banda Balakallpa; unidad elemental de Katûpirsia; nombre-guide 44)',
    cta_translate: 'Proponer una traducción del concepto',
    h_def: 'Definición operativa',
    chips: ['Elemento', 'Tótem', 'Frecuencia'],
    title_img: IMG_IDEOGRAM_CONCEPT,
    chip_urls: [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_44],
    def_short: 'Fragment vibratoire actif ; unité fractale de transmission et de seuil.',
    def_long:
      'Porta una carga de sentido autónoma mientras permanece ligado al todo. Activa una recomposición por la parte: umbral operativo, nodo de RéZonans, módulo transitorio de transformación.\n\n' +
      'En Katûpirsia 5, Àpákan está definido como la unidad vibratoria elemental de Katûpirsia. Se da como forma viva y zona vibratoria fractal, partícula de transmisión que revela la arquitectura posœnnoïal de lo múltiple dentro de la unidad fluida.\n\n' +
      'Àpákan fragmenta sin romper. Vuelve practicable el pasaje por la parte: porción singular de un campo energético, nodo de sentido distinto y ligado, capaz de abrir un umbral, anclar una modulación ritual y reconfigurar sintonías por su sola intensidad.\n\n' +
      'Dentro de Katûpirsia, Àpákan funciona como órgano simbólico autónomo y unidad procesual de activación. Cruza intención, memoria, RéZonans y materialización para engendrar una expresión transitoria del todo—localizada pero ligada. En Axis, diez Àpákan fundamentales estructuran el núcleo vibratorio del Organon cerca de Posœnnoïa.',
    h_features: 'Despliegue',
    h_questions: 'Pruebas de uso',
    hint_fold: 'desplegar',
    hint_fold2: 'desplegar',
    hint_fold3: 'desplegar',
    example_title: 'Frase operativa',
    example: '« Àpákan: abro la llamada, corto el umbral y activo la unidad viva que recompone el todo. »',
    features: [
      'Estatus canónico: unidad vibratoria elemental de Katûpirsia; forma viva y zona vibratoria fractal, partícula de transmisión que revela la arquitectura de lo múltiple en la unidad fluida.',
      'Función principal: fragmenta sin romper; vuelve practicable el pasaje por la parte, capaz de abrir un umbral, anclar una modulación ritual y reconfigurar sintonías por intensidad.',
      'Segmentación rítmica canónica: À–Pá–Kan (llamada → corte → activación).',
      'Relaciones sistémicas: Katûpirsia, La Katûvýs, Axis; medios de uso: Katûvýs picturale, Katûpirsia, Katûvýsqun, Synchrêssions.',
      'Modo de invocación: nombrar el Àpákan, portar la frase de intensidad si está individualizado, acordar la firma 44, dejar actuar la tríada operativa.'
    ],
    questions: [
      'Si quieres abrir un pasaje por un fragmento: « activo un Àpákan ».',
      'Si una parte debe hablar por el todo: « este Àpákan porta la carga ».',
      'Si la recomposición opera localmente: « el Àpákan trabaja ».',
      'Si un fragmento debe acordarse al campo sin disolverse: « sostengo el Àpákan y el todo responde ».'
    ],
    h_family: 'Posición y relaciones',
    family_1: '<p><strong>Posición sistémica:</strong> dentro de <strong>Katûpirsia</strong>, <strong>Àpákan</strong> funciona como órgano simbólico autónomo y unidad procesual de activación. Cruza intención, memoria, <strong>RéZonans</strong> y materialización para generar una expresión transitoria del todo—localizada pero ligada.</p>',
    family_2: '<p><strong>Elemento / Tótem / Firma:</strong> Elemento: <strong>La Katûvýs</strong>; Tótem: <strong>Êkhö</strong>; Frecuencia (<strong>nombre-guide</strong>): 44. Àpákan actúa como fragmento activo bañado en la matriz-substrato, portador de una cualidad de pasaje y de una tenida propia orientada hacia la recomposición.</p>',
    h_wordbuild: 'Construcción del nombre y frecuencia 44',
    word_blocks: [
      { head: 'Origen (K5)', text: 'Construcción neológica: yorùbá (àpá + kan), estabilizada por K5.' },
      { head: 'àpá', text: 'Sentido atestiguado: parte, porción, lado, segmento. Resonancia posœnnoïal: fragmento operativo, zona de condensación.' },
      { head: 'kan', text: 'Sentido atestiguado: uno, único, distinto. Resonancia posœnnoïal: singularidad activa, unidad de activación.' },
      { head: 'Tríada À–Pá–Kan', text: 'À: aliento inicial, llamada, apertura de la invocación. Pá: corte / delimitación; nacimiento de un espacio simbólico. Kan: unidad activa; singularidad vibratoria activable.' },
      { head: 'Frecuencia 44', text: '44 actúa como firma vibratoria mínima: eje de nombramiento, vibración, invocación y proyección ritual. 4 + 4 = 8: transmutación dominada, estructura estable, resonancia equilibrada; 2 × 22: doble estructura de palabra fundadora y de ciclo dual estabilizado.' }
    ],
    word_notes: [
      'Campo: Katûpirsia / La Katûvýs ; Tótem: Êkhö ; Frecuencia: 44.',
      'El paradigma es explícito: el fragmento porta memoria del todo; su activación participa en una recomposición permanente por remanencia, sintonía y activación transitoria.',
      'El título permanece en FR (término del léxico), cualquiera que sea la lengua de la interfaz.'
    ]
  };

  function getFallback(lang){
    var l = normLang(lang) || 'fr';
    if (l === 'en') return FALLBACK_EN;
    if (l === 'es') return FALLBACK_ES;
    return FALLBACK_FR;
  }

  function getAxisLexId(node){
    try{ return node.getAttribute('data-po-lex-id') || ''; }catch(e){ return ''; }
  }

  function lockNode(el){
    if (!el || !el.setAttribute) return;
    try{ el.setAttribute('translate', 'no'); }catch(e){}
    try{ if (el.classList){ el.classList.add('notranslate'); el.classList.add('po-lex-slotlock'); } }catch(e){}
  }

  function normalizeCanonicalFrench(text){
    var s = clampStr(text);
    if (!s) return s;
    s = s.replace(/\bguide-number\b/gi, 'nombre-guide');
    s = s.replace(/\bn[uú]mero-gu[ií]a\b/gi, 'nombre-guide');
    return s;
  }

  function firstNonEmpty(){
    for (var i=0;i<arguments.length;i++){
      var v = arguments[i];
      if (Array.isArray(v)){
        if (v.length) return v;
      } else if (clampStr(v)) return v;
    }
    return Array.isArray(arguments[0]) ? [] : '';
  }

  function getAxisData(node, lang){
    var l = normLang(lang) || 'fr';
    var base = getFallback(l);
    var out = {};
    for (var k in base) out[k] = base[k];
    var lexId = getAxisLexId(node);
    var entry = lexId ? getLexiconEntry(lexId) : null;

    out.title = CANON.title;

    if (entry){
      var frTerm = firstNonEmpty(pickTerm(entry, 'fr'), CANON.title);
      out.title = frTerm;
      if (l === 'fr'){
        out.def_short = firstNonEmpty(pickDefShort(entry, 'fr'), out.def_short);
        out.def_long = firstNonEmpty(pickDefLong(entry, 'fr'), out.def_long);
        var fFR = firstNonEmpty(pickArray(entry, 'fr', 'features'), pickArray(entry, 'fr', 'characteristics'), out.features);
        var qFR = firstNonEmpty(pickArray(entry, 'fr', 'questions'), pickArray(entry, 'fr', 'usage_questions'), out.questions);
        out.features = fFR;
        out.questions = qFR;
      }
      out.kicker = firstNonEmpty(
        pickAny(entry, 'kicker_' + l, ''),
        pickAny(entry, 'kicker_fr', ''),
        pickAny(entry, 'kicker', ''),
        out.kicker
      );
    }

    out.title = CANON.title;
    out.title_img = base.title_img || IMG_IDEOGRAM_CONCEPT;
    out.chip_urls = base.chip_urls || [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_44];
    out.def_short = normalizeCanonicalFrench(out.def_short);
    out.def_long = normalizeCanonicalFrench(out.def_long);
    return out;
  }

  function qs(root, sel){ try{ return root.querySelector(sel); }catch(e){ return null; } }

  function setSlotText(root, slot, txt){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    el.textContent = normalizeCanonicalFrench(clampStr(txt));
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    el.innerHTML = protectKeywordsHTML(normalizeCanonicalFrench(clampStr(html)));
    protectKeywordsInElement(el);
  }

  function setSlotImg(root, slot, src, alt){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    var s = clampStr(src), a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute('src'); }catch(e){}
      try{ el.setAttribute('alt', ''); }catch(e){}
      try{ el.style.display = 'none'; }catch(e){}
      return;
    }
    try{ el.setAttribute('src', s); }catch(e){}
    try{ el.setAttribute('alt', a); }catch(e){}
    try{ el.style.display = ''; }catch(e){}
  }

  function setSlotImgSrc(root, slot, src, alt){ setSlotImg(root, slot, src, alt); }

  function renderList(root, slot, items){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push('<li>' + protectKeywordsHTML(normalizeCanonicalFrench(clampStr(arr[i]))) + '</li>');
    el.innerHTML = out.join('');
    protectKeywordsInElement(el);
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    var t = normalizeCanonicalFrench(clampStr(exampleTitle));
    var x = normalizeCanonicalFrench(clampStr(exampleText));
    if (!t && !x){ el.innerHTML = ''; return; }
    el.innerHTML = '<div class="po-lex-example__title"><strong>' + protectKeywordsHTML(t) + '</strong></div>' +
      '<div class="po-lex-example__text">' + protectKeywordsHTML(x) + '</div>';
    protectKeywordsInElement(el);
  }

  function renderWordBlocks(root, slot, blocks){
    var el = qs(root, '[data-po-slot="' + slot + '"]');
    if (!el) return;
    lockNode(el);
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      out.push('<div class="po-axis-wb"><div class="po-axis-wb__h">' + protectKeywordsHTML(normalizeCanonicalFrench(clampStr(b.head))) + '</div><div class="po-axis-wb__t">' + protectKeywordsHTML(normalizeCanonicalFrench(clampStr(b.text))) + '</div></div>');
    }
    el.innerHTML = out.join('');
    protectKeywordsInElement(el);
  }

  function applyToAxis(node, lang){
    var data = getAxisData(node, lang);
    var chipUrls = Array.isArray(data.chip_urls) ? data.chip_urls : [IMG_ELEMENT, IMG_TOTEM, IMG_FREQ_44];
    setSlotImgSrc(node, 'title_img', data.title_img || IMG_IDEOGRAM_CONCEPT, data.title || CANON.title);
    setSlotText(node, 'title', data.title || CANON.title);
    setSlotHTML(node, 'kicker', data.kicker || '');
    setSlotText(node, 'h_def', data.h_def || '');

    var chips = Array.isArray(data.chips) ? data.chips : [];
    setSlotText(node, 'chip_1', chips[0] || '');
    setSlotText(node, 'chip_2', chips[1] || '');
    setSlotText(node, 'chip_3', chips[2] || '');
    setSlotImgSrc(node, 'chip_1_img', chipUrls[0] || IMG_ELEMENT, chips[0] || '');
    setSlotImgSrc(node, 'chip_2_img', chipUrls[1] || IMG_TOTEM, chips[1] || '');
    setSlotImgSrc(node, 'chip_3_img', chipUrls[2] || IMG_FREQ_44, chips[2] || '');

    setSlotHTML(node, 'def_short', htmlParagraphize(data.def_short || ''));
    setSlotHTML(node, 'def_long', htmlParagraphize(data.def_long || ''));

    setSlotText(node, 'h_features', data.h_features || '');
    setSlotText(node, 'hint_fold', data.hint_fold || '');
    renderList(node, 'features', data.features || []);

    setSlotText(node, 'h_questions', data.h_questions || '');
    setSlotText(node, 'hint_fold2', data.hint_fold2 || data.hint_fold || '');
    renderList(node, 'questions', data.questions || []);
    renderExampleBox(node, 'example_box', data.example_title || '', data.example || '');

    setSlotText(node, 'h_family', data.h_family || '');
    setSlotText(node, 'hint_fold3', data.hint_fold3 || data.hint_fold || '');
    setSlotHTML(node, 'family_1', data.family_1 || '');
    setSlotHTML(node, 'family_2', data.family_2 || '');

    setSlotText(node, 'h_wordbuild', data.h_wordbuild || '');
    renderWordBlocks(node, 'wordbuild_blocks', data.word_blocks || []);
    renderList(node, 'wordbuild_notes', data.word_notes || []);

    setSlotText(node, 'cta_translate', data.cta_translate || '');
  }

  function hasLexiconReady(){
    try{
      if (window.PO_LEXICON_MAP) return true;
      if (Array.isArray(window.PO_LEXICON) && window.PO_LEXICON.length) return true;
      if (window.PO_LEXICON_META && window.PO_LEXICON_META.lexique_simplifie_fr) return true;
    }catch(e){}
    return false;
  }

  function applyLangEverywhere(lang){
    var l = normLang(lang) || getLang() || 'fr';
    storeLang(l);
    var roots = getTargetBlocks();
    for (var i=0;i<roots.length;i++) applyToAxis(roots[i], l);
    initAudioEverywhere(l);
    notifyLocaleChanged();
    return l;
  }

  var __PO_APAKAN_LISTENERS_SET__ = false;
  var __PO_APAKAN_OBSERVER__ = null;

  function init(){
    if (!readStoredLang()) storeLang(detectBrowserLang());
    applyLangEverywhere(getLang());

    if (!__PO_APAKAN_LISTENERS_SET__){
      __PO_APAKAN_LISTENERS_SET__ = true;
      window.addEventListener('po:lexicon-ready', function(){
        __PO_PROTECT_CACHE__.key = '';
        __PO_PROTECT_CACHE__.re = null;
        applyLangEverywhere(getLang());
      });

      try{
        if (document && document.documentElement && !__PO_APAKAN_OBSERVER__){
          __PO_APAKAN_OBSERVER__ = new MutationObserver(function(muts){
            if (__PO_HTML_LANG_SYNC__) return;
            for (var i=0;i<muts.length;i++){
              if (muts[i].type === 'attributes' && muts[i].attributeName === 'lang'){
                applyLangEverywhere(getLang());
                break;
              }
            }
          });
          __PO_APAKAN_OBSERVER__.observe(document.documentElement, { attributes:true });
        }
      }catch(e){}
    }

    if (!hasLexiconReady()){
      var tries = 0;
      var maxTries = 24;
      var it = setInterval(function(){
        tries++;
        if (hasLexiconReady() || tries >= maxTries){
          clearInterval(it);
          __PO_PROTECT_CACHE__.key = '';
          __PO_PROTECT_CACHE__.re = null;
          applyLangEverywhere(getLang());
        }
      }, 250);
    }
  }

  window.PoKatupirsia5ApakanTextsFR_EN_ES_20260305 = {
    init: init,
    getLang: getLang,
    normLang: normLang,
    setLang: function(raw){
      var l = normLang(raw) || 'fr';
      return applyLangEverywhere(l);
    },
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.init = init;
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = function(lang){ return window.PoKatupirsia5ApakanTextsFR_EN_ES_20260305.setLang(lang); };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
